import { ErrorBuilder } from "@flaminem/utils";

import { ErrorCode, getErrorBuilder } from "src/graphql/utils/errorBuilder";
import { useErrorDefinitions } from "src/graphql/utils/errorDefinitions";

export const useCreateError = () => {
  const errorDefinitions = useErrorDefinitions();
  return getErrorBuilder<ErrorCode>(errorDefinitions) as ErrorBuilder<ErrorCode>;
};
